import { ReactElement, useEffect, useState } from 'react';

interface Props {
  triggerResendVerify: boolean;
}

let interval: ReturnType<typeof setInterval> | null = null;
export function Pin(props: Props): ReactElement {
  const [minute, setMinute] = useState<number>(4);
  const [second, setSecond] = useState<number>(60);
  const [timeUp, setTimeUp] = useState<boolean>(false);
  const [trigger, setTrigger] = useState<number>(0);

  useEffect(() => {
    if (!timeUp) {
      if (minute < 0) {
        setTimeUp(true);
        setMinute(0);
        setSecond(0);
        if (interval) {
          clearInterval(interval);
        }
      }

      if (second <= 0) {
        if (minute <= 0) {
          setSecond(0);
        } else {
          setMinute((prev) => prev - 1);
          setSecond(60);
        }
      } else {
        setSecond((prev) => prev - 1);
      }
    } else {
      if (interval) {
        clearInterval(interval);
      }
    }
    /* eslint-disable-next-line */
  }, [trigger]);

  const timerFunction = () => {
    const savedTime = localStorage.getItem('pin_time');
    if (savedTime) {
      const startTime = new Date(savedTime);
      const endTime = new Date();
      const difference = endTime.getTime() - startTime.getTime(); // This will give difference in milliseconds
      const resultInMinutes = Math.round(difference / 60000);
      if (resultInMinutes) {
        if (resultInMinutes > 5) {
          setMinute(-1);
          setSecond(-1);
          setTimeUp(true);
        }
        const remaining = 5 - resultInMinutes;
        if (remaining >= 0) {
          setMinute(remaining);
        }
      }
    } else {
      localStorage.setItem('pin_time', new Date().toString());
    }

    interval = setInterval(() => {
      setTrigger((t) => t + 1);
    }, 1000);
  };

  useEffect(() => {
    setMinute(4);
    setSecond(60);
    setTrigger(0);
    setTimeUp(false);
  }, [props.triggerResendVerify]);

  useEffect(() => {
    timerFunction();
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, []);
  return (
    <div>
      <p className="text-gray">Please enter a PIN sent to your email</p>
      <hr className="text-gray" style={{ opacity: '0.1' }} />
      <div style={{ fontSize: '12px' }}>
        <span className="text-gray">PIN(4 digit) Sent Pin is Valid for</span>
        <span className="text-gray" style={{ width: '35px', marginLeft: '2px', marginRight: '2px' }}>
          {String(minute <= 0 ? 0 : minute).padStart(2, '0')}:{String(second <= 0 ? 0 : second).padStart(2, '0')}
        </span>
        <span className="text-gray">minutes</span>
      </div>
    </div>
  );
}
